( function ( $ ) {

   const target = $('#observer')[0]

   const options = {
        root: null, 
        rootMargin: '200px', 
        threshold: 1
  };

   function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        $('.scroll-top').css('display', 'none')
        
      } else {
        $('.scroll-top').css('display', 'flex')
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, options);

  observer.observe(target);

} )( jQuery );